import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("UI crash caught by ErrorBoundary:", error, info);

    /* A deploy replaces the hashed chunk files. Any session that was already
       open is still asking for the previous hashes, so the next lazy-loaded
       route throws ChunkLoadError and lands here - the user sees a crash for
       what is really just a stale tab. Reload once (guarded by sessionStorage
       so a genuinely broken chunk cannot loop) to pick up the new bundle. */
    if (ErrorBoundary.isChunkLoadError(error)) {
      try {
        if (!sessionStorage.getItem("cs_chunk_reloaded")) {
          sessionStorage.setItem("cs_chunk_reloaded", String(Date.now()));
          window.location.reload();
        }
      } catch (e) {
        /* storage unavailable (private mode): fall through to the error card */
      }
    }
  }

  static isChunkLoadError(error) {
    const name = (error && error.name) || "";
    const msg = (error && error.message) || "";
    return (
      name === "ChunkLoadError" ||
      /Loading chunk [\w-]+ failed/i.test(msg) ||
      /Loading CSS chunk/i.test(msg) ||
      /dynamically imported module/i.test(msg)
    );
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="csx">
        <div className="csx-page" style={{ alignItems: "center", justifyContent: "center", padding: 24 }}>
          <div className="card card-pad" style={{ maxWidth: 440, textAlign: "center" }}>
            <div className="t-h2">
              {ErrorBoundary.isChunkLoadError(this.state.error) ? "Update available" : "Something went wrong"}
            </div>
            <p className="t-sm mt-2">
              {ErrorBoundary.isChunkLoadError(this.state.error)
                ? "CareerSavvy was updated while this tab was open. Reload to get the latest version - your data is safe."
                : "This section hit an unexpected error. Your data is safe. Reload the page to continue."}
            </p>
            <div className="row mt-3" style={{ justifyContent: "center" }}>
              <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
                Reload page
              </button>
              <a className="btn btn-ghost" href="/dashboard">
                Go to dashboard
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
